export default __webpack_public_path__ + "static/media/RequestsIcon.46fa446d.svg";